export function getBackendBaseUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;

  if (typeof window === 'undefined') {
    return envUrl || '';
  }

  // If env isn't set, assume same-origin (works for preview/prod)
  if (!envUrl) return window.location.origin;

  const envIsLocalhost = envUrl.includes('localhost') || envUrl.includes('127.0.0.1');
  const browserIsLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  // In preview/prod, REACT_APP_BACKEND_URL is often set to a localhost URL for internal routing,
  // but the browser can't reach it. In that case, use same-origin so `/api/*` routes work.
  if (envIsLocalhost && !browserIsLocalhost) {
    return window.location.origin;
  }

  return envUrl;
}

export const BACKEND_BASE_URL = getBackendBaseUrl();
export const API_BASE_URL = `${BACKEND_BASE_URL}/api`;
